//React
import React, { useEffect, useState, useContext } from "react";

//Material
import {
  Grid,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MaskService from "../../../../utils/mask/maskService";

//OurComponents
import SelectErp from "../../../../components/basics/SelectErp";
import Chip from "../../../../components/basics/Chip";
import { FornecedorContext } from "../contexts/FornecedorContext";
import { HeaderAccordion } from "../styles/Fornecedor";

//Controller (functions)
import useFornecedorController from "../controllers/FornecedorController";
import TextFieldErp from "../../../../components/basics/TextFieldErp";

let temporizer = null;
const TabFornecedoresGeral = ({ ...props }) => {
  const {
    //Geral
    geralCpfcnpj,
    setGeralCpfCnpj,
    geralRazao,
    setGeralRazao,
    geralFantasia,
    setGeralFantasia,
    geralCep,
    setGeralCEP,
    geralEndereco,
    setGeralEndereco,
    geralNumero,
    setGeralNumero,
    geralComplemento,
    setGeralComplemento,
    geralBairro,
    setGeralBairro,
    geralEstado,
    setGeralEstado,
    geralMunicipio,
    geralPais,
    setGeralPais,
    geralTel,
    setGeralTel,
    geralEmail,
    setGeralEmail,
    geralIe,
    setGeralIe,
    geralSm,
    setGeralSm,
    geralCf,
    setGeralCf,
    geralIm,
    setGeralIm,
    geralErrors,
    listUf,
    listCounty,
    listNation,
    geralAtivo,
    setGeralAtivo,
    expanded,
    IeIndication,
    setIeIndication,
    IeIndicationList,
    loadingInputs,
    ruralProducer,
    setRuralProducer,
    validCpfCnpj,

    geralCelular,
    setGeralCelular,
    geralWhatsappAtivo,
    setGeralWhatsappAtivo,
  } = useContext(FornecedorContext);

  const {
    handleCidade,
    handleNumInscricao,
    handleChangeCep,
    handleChangeOpenAcordion,
  } = useFornecedorController();

  const [IeIndicationOpen, setIeIndicationOpen] = useState(false);

  const handleInputUser = (e) => {
    let newInput = e.target.value.replaceAll(/[^0-9]/g, "");
    let mask;
    let updatedInput = newInput;

    if (newInput.length === 14) {
      mask = "cnpj";
      updatedInput = MaskService.toMask(mask, newInput);
    } else if (newInput.length === 11) {
      mask = "cpf";
      updatedInput = MaskService.toMask(mask, newInput);
    }
    setGeralCpfCnpj(updatedInput);

    clearTimeout(temporizer);
    temporizer = setTimeout(() => {
      handleNumInscricao(updatedInput);
    }, 1800);
  };

  useEffect(() => {
    if (IeIndication) {
      setIeIndicationOpen(true);
    }
  }, [IeIndication]);

  // View
  return (
    <Grid item xs={12}>
      <Accordion
        expanded={expanded?.general || false}
        onChange={() => handleChangeOpenAcordion("general")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <HeaderAccordion>
            <Grid container>
              <Grid item xs={12}>
                <Chip
                  bgcolor="primary"
                  textcolor="white"
                  label="DADOS GERAIS"
                />
              </Grid>
            </Grid>
          </HeaderAccordion>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item lg={4} md={3} sm={6} xs={12}>
              <TextFieldErp
                id="geralCpfcnpj"
                label="CPF, CNPJ ou CÓD*"
                value={geralCpfcnpj}
                setValue={setGeralCpfCnpj}
                onBlur={(e) => handleInputUser(e)}
                helperText={geralErrors.geralCpfcnpj || ""}
                error={geralErrors.geralCpfcnpj ? true : false}
                disabled={validCpfCnpj}
              />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralRazao"
                label="Razão / Nome*"
                value={geralRazao}
                setValue={setGeralRazao}
                helperText={geralErrors.geralRazao || ""}
                error={geralErrors.geralRazao ? true : false}
              />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="fantasia"
                label="Fantasia*"
                value={geralFantasia}
                setValue={setGeralFantasia}
                helperText={geralErrors.geralFantasia || ""}
                error={geralErrors.geralFantasia ? true : false}
              />
            </Grid>
            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralCep"
                label="CEP*"
                value={geralCep}
                setValue={setGeralCEP}
                helperText={geralErrors.geralCep || ""}
                error={geralErrors.geralCep ? true : false}
                onChange={(value) => handleChangeCep(value, "general")}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="endereco"
                label="Endereço*"
                value={geralEndereco}
                setValue={setGeralEndereco}
                helperText={geralErrors.geralEndereco || ""}
                error={geralErrors.geralEndereco ? true : false}
              />
            </Grid>
            <Grid item lg={1} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="numero"
                label="Número*"
                value={geralNumero}
                setValue={setGeralNumero}
                helperText={geralErrors.geralNumero || ""}
                error={geralErrors.geralNumero ? true : false}
              />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="complemento"
                label="Complemento"
                value={geralComplemento}
                setValue={setGeralComplemento}
                helperText={geralErrors.geralComplemento || ""}
                error={geralErrors.geralComplemento ? true : false}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="bairro"
                label="Bairro*"
                value={geralBairro}
                setValue={setGeralBairro}
                helperText={geralErrors.geralBairro || ""}
                error={geralErrors.geralBairro ? true : false}
              />
            </Grid>
            <Grid item lg={2} md={6} sm={6} xs={12}>
              <SelectErp
                id="geralEstado"
                label="Estado*"
                optionsList={listUf}
                loading={loadingInputs?.listUf || false}
                value={geralEstado}
                setValue={setGeralEstado}
                descriptionField="estado"
                helperText={geralErrors.geralEstado || ""}
                error={geralErrors.geralEstado ? true : false}
              />
            </Grid>
            <Grid item lg={2} md={6} sm={6} xs={12}>
              <SelectErp
                id="geralMunicipio"
                loading={loadingInputs?.listCounty || false}
                label="Município*"
                value={geralMunicipio}
                onChange={handleCidade}
                optionsList={
                  geralEstado
                    ? listCounty.filter(
                        (opt) => opt.estado_codigo === geralEstado.codibge
                      )
                    : []
                }
                descriptionField="municipio"
                helperText={geralErrors.geralMunicipio || ""}
                error={geralErrors.geralMunicipio ? true : false}
              />
            </Grid>
            <Grid item lg={2} md={6} sm={6} xs={12}>
              <SelectErp
                loading={loadingInputs?.listNation || false}
                id="geralPais"
                label="País"
                optionsList={listNation}
                value={geralPais}
                setValue={setGeralPais}
                descriptionField="descricao"
                helperText={geralErrors.geralPais || ""}
                error={geralErrors.geralPais ? true : false}
              />
            </Grid>
            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralTel"
                label="Telefone"
                value={geralTel}
                setValue={setGeralTel}
                helperText={geralErrors.geralTel || ""}
                error={geralErrors.geralTel ? true : false}
                mask="cel-phone"
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralEmail"
                label="Email"
                value={geralEmail}
                setValue={setGeralEmail}
                helperText={geralErrors.geralEmail || ""}
                error={geralErrors.geralEmail ? true : false}
              />
            </Grid>
            <Grid item lg={2} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralIe"
                label="IE / RG"
                value={geralIe}
                setValue={setGeralIe}
                helperText={geralErrors.geralIe || ""}
                error={geralErrors.geralIe ? true : false}
              />
            </Grid>
            <Grid item lg={2} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralIm"
                label="Inscrição Municipal"
                value={geralIm}
                setValue={setGeralIm}
                helperText={geralErrors.geralIm || ""}
                error={geralErrors.geralIm ? true : false}
              />
            </Grid>
            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralCelular"
                label="Celular"
                value={geralCelular}
                setValue={setGeralCelular}
                mask="cel-phone"
              />
            </Grid>
            <Grid item lg={1} md={6} sm={6} xs={12}>
              <FormControlLabel
                value="end"
                control={
                  <Switch
                    checked={geralWhatsappAtivo}
                    onChange={() =>
                      setGeralWhatsappAtivo((current) => !current)
                    }
                    color="primary"
                  />
                }
                label="Whatsapp"
                labelPlacement="end"
              />
            </Grid>
            <Grid item container spacing={3}>
              <Grid item lg={2} md={6} sm={6} xs={12}>
                <FormControlLabel
                  value="end"
                  control={
                    <Switch
                      checked={IeIndicationOpen}
                      onChange={() =>
                        setIeIndicationOpen((current) => !current)
                      }
                      color="primary"
                    />
                  }
                  label="Indicação IE?"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item lg={2} md={6} sm={6} xs={12}>
                <SelectErp
                  disabled={!IeIndicationOpen}
                  label="Indicação IE"
                  value={IeIndication}
                  setValue={setIeIndication}
                  optionsList={IeIndicationList}
                  descriptionField="description"
                />
              </Grid>
            </Grid>
            <Grid item container spacing={3}>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <FormControlLabel
                  value="end"
                  control={
                    <Switch
                      checked={geralSm}
                      onChange={() => setGeralSm((current) => !current)}
                      color="primary"
                    />
                  }
                  label="Optante pelo simples nacional"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <FormControlLabel
                  value="end"
                  control={
                    <Switch
                      checked={geralCf}
                      onChange={() => setGeralCf((current) => !current)}
                      color="primary"
                    />
                  }
                  label="Consumidor Final"
                  labelPlacement="end"
                />
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={12}>
                <FormControlLabel
                  value="end"
                  control={
                    <Switch
                      checked={ruralProducer}
                      onChange={() => setRuralProducer((current) => !current)}
                      color="primary"
                    />
                  }
                  label="Produtor Rural"
                  labelPlacement="end"
                />
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={geralAtivo}
                      onChange={() => setGeralAtivo((current) => !current)}
                      color="primary"
                    />
                  }
                  label="Ativo"
                  labelPlacement="end"
                />
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default TabFornecedoresGeral;
